import localforage from 'localforage'
import _ from 'lodash'

class NomBouteille {
    getList(callback) {
        localforage
            .getItem('listNomBout')
            .then(noms => {
                callback(_.sortBy(JSON.parse(noms), ['nom']))
            })
            .catch(error => {
            })
    }
}

export default NomBouteille



// WEBPACK FOOTER //
// ./src/js/models/NomBouteille.js